/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { Search, RotateCw } from 'lucide-react'
import { useEffect, useState } from 'react'
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  InputGroup,
  Row,
  Table
} from 'react-bootstrap'
import { Loader } from 'react-bootstrap-typeahead'
import { useLocation, useNavigate } from 'react-router-dom'
import RowEmpty from '../../../components/atoms/RowEmpty'
import TableAction from '../../../components/atoms/Table/TableAction'
import TablePagination from '../../../components/atoms/Table/TablePagination'
import InputDatePicker from '../../../components/Input/DatePicker/InputDatePicker'
import ModalCreate from '../../../components/modal/ReceiveAtWarehousePlan/ModalCreate'
import Notification from '../../../components/Notifications/Notification'
import api from '../../../config/AxiosInstance'
import { convertDateWithTime } from '../../../helpers/constants'
import * as Common from '../../../utils/Common'

const headerTitleStyle = {
  color: 'var(--primary-orange)',
  fontSize: '24px',
  fontWeight: '600'
}

const tableHeaderStyle = {
  fontSize: '14px',
  fontWeight: '600',
  color: '#333333',
  letterSpacing: '0.5px',
  backgroundColor: '#f8f9fa',
  borderBottom: '2px solid #e9ecef'
}

const cardFilterStyle = {
  border: 'none',
  boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
  borderRadius: '12px',
  padding: '1.5rem',
  marginBottom: '1.5rem',
  backgroundColor: '#fff'
}

const labelStyle = {
  fontSize: '0.75rem',
  fontWeight: '700',
  color: '#333333',
  textTransform: 'uppercase',
  marginBottom: '0.5rem',
  letterSpacing: '0.5px'
}

const FormControlStyle = {
  height: '45px',
  borderRadius: '10px',
  border: '1px solid #e9ecef',
  backgroundColor: '#ffffff',
  fontSize: '0.9rem'
}

const MaterialTransfer = () => {
  const { state } = useLocation()
  const navigate = useNavigate()
  const [show, setShow] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [notificationSuccess, setNotificationSuccess] = useState(false)
  const [filter, setFilter] = useState({
    date_start: state?.date_start || '',
    date_end: state?.date_end || '',
    tr: state?.tr || ''
  })
  const [debouncedTr, setDebouncedTr] = useState(filter.tr)

  const [disabledCreateML, setDisabledCreateML] = useState({})
  const [createMl, setCreateMl] = useState({
    mlId: null,
    code: null,
    series_number: null
  })
  const [listData, setListData] = useState([])
  const [disableSubmit, setDisableSubmit] = useState(false)
  const [meta, setMeta] = useState({
    per_page: 10,
    current_page: 1,
    total_row: 0,
    total_page: 0
  })

  const fetchListData = async (page = null) => {
    try {
      setIsLoading(true)
      const params = {
        per_page: meta.per_page,
        page: page || meta.current_page,
        tr: debouncedTr,
        date_start:
          filter.date_start !== '' && filter.date_start
            ? convertDateWithTime(filter.date_start, 'YYYY-MM-DD')
            : '',
        date_end:
          filter.date_end !== '' && filter.date_end
            ? convertDateWithTime(filter.date_end, 'YYYY-MM-DD')
            : ''
      }
      const res = await api.get('/inbound/ml-plan/stock-entry', { params })
      const { data } = res
      if (data.success) {
        setListData(data.data)
        setMeta(data.metadata)
      } else {
        setListData([])
      }
    } catch (error) {
      if (error?.response?.status !== 404) {
        const err = error.response.data.errors.message || 'An error occurred'
        Common.showPopUpErrorMessage(err)
      } else {
        setListData([])
      }
    } finally {
      setIsLoading(false)
    }
  }

  const handleOnChangeMeta = (e) => {
    setMeta((prevMeta) => ({
      ...prevMeta,
      per_page: parseInt(e.target.value, 10),
      current_page: 1
    }))
  }

  const handlePageChange = (data) => {
    setMeta((prevMeta) => ({
      ...prevMeta,
      current_page: data.selected + 1
    }))
    window.scrollTo(0, 0)
  }

  const handleChangeInput = (name, value) => {
    setFilter((prevFilter) => ({
      ...prevFilter,
      [name]: value
    }))
  }

  const handleDateChange = (name, date) => {
    setFilter((prev) => ({
      ...prev,
      [name]: date
    }))
    setMeta((prev) => ({ ...prev, current_page: 1 }))
  }

  const handleCreateMlDraft = async () => {
    navigate('/arrival/material-transfer/create', {
      replace: true,
      state: {
        ...filter,
        code: createMl?.mlId,
        seriesNumber: createMl.series_number
      }
    })
  }

  const handleReset = () => {
    setFilter({
      date_start: '',
      date_end: '',
      tr: ''
    })
    setDebouncedTr('')
    setMeta((prev) => ({ ...prev, current_page: 1 }))
  }

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedTr(filter.tr)
      setMeta((prev) => ({ ...prev, current_page: 1 }))
    }, 1000)
    return () => clearTimeout(handler)
  }, [filter.tr])

  useEffect(() => {
    const isDateValid =
      (!filter.date_start && !filter.date_end) ||
      (filter.date_start && filter.date_end)

    if (isDateValid) {
      fetchListData()
    }
  }, [
    meta.per_page,
    meta.current_page,
    debouncedTr,
    filter.date_start,
    filter.date_end
  ])

  useEffect(() => {
    if (notificationSuccess) {
      const timer = setTimeout(() => {
        setNotificationSuccess(false)
      }, 10000)
      return () => clearTimeout(timer)
    }
  }, [notificationSuccess])

  return (
    <>
      <Container fluid className="px-4">
        <Row className="mb-4 align-items-center">
          <Col>
            <h3 style={headerTitleStyle}>Material Transfer</h3>
          </Col>
          <Col className="text-end">
            <Button
              variant="light"
              className="text-secondary fw-bold rounded px-3 border"
              onClick={handleReset}
              style={{ fontSize: '0.85rem', height: '37px' }}
            >
              <RotateCw size={16} className="me-2" />
              Reset Filters
            </Button>
          </Col>
          {notificationSuccess && (
            <Notification
              type="success"
              text="ML draft created!"
              handleClose={() => setNotificationSuccess(false)}
              link=""
            />
          )}
        </Row>

        <Card style={cardFilterStyle}>
          <Row className="g-3">
            <Col md={3}>
              <Form.Group>
                <Form.Label style={labelStyle}>#TR</Form.Label>
                <InputGroup>
                  <InputGroup.Text
                    style={{
                      backgroundColor: '#f8f9fa',
                      border: '1px solid #e9ecef',
                      borderRight: 'none',
                      borderTopLeftRadius: '10px',
                      borderBottomLeftRadius: '10px'
                    }}
                  >
                    <Search size={16} className="text-muted" />
                  </InputGroup.Text>
                  <Form.Control
                    type="text"
                    name="tr"
                    id="tr"
                    placeholder="Search TR"
                    onChange={(e) =>
                      handleChangeInput(e.target.name, e.target.value)
                    }
                    value={filter.tr}
                    style={{
                      ...FormControlStyle,
                      borderLeft: 'none',
                      borderTopLeftRadius: 0,
                      borderBottomLeftRadius: 0
                    }}
                  />
                </InputGroup>
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label style={labelStyle}>Start Date</Form.Label>
                <div
                  style={FormControlStyle}
                  className="d-flex align-items-center px-2"
                >
                  <InputDatePicker
                    value={filter.date_start}
                    onChange={(value) => handleDateChange('date_start', value)}
                    clearIcon
                  />
                </div>
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label style={labelStyle}>End Date</Form.Label>
                <div
                  style={FormControlStyle}
                  className="d-flex align-items-center px-2"
                >
                  <InputDatePicker
                    value={filter.date_end}
                    onChange={(value) => handleDateChange('date_end', value)}
                    clearIcon
                  />
                </div>
              </Form.Group>
            </Col>
          </Row>
        </Card>

        <Row className="mt-4">
          <Col md={12}>
            <Table
              hover
              responsive
              className="shadow-sm mb-5 bg-white"
              style={{
                borderRadius: '12px',
                overflow: 'hidden',
                fontSize: '0.9rem'
              }}
            >
              <thead style={{ backgroundColor: '#f8f9fa' }}>
                <tr>
                  <th className="p-2 align-middle" style={tableHeaderStyle}>
                    Plan Date
                  </th>
                  <th className="p-2 align-middle" style={tableHeaderStyle}>
                    TR
                  </th>
                  <th className="p-2 align-middle" style={tableHeaderStyle}>
                    Destination Warehouse
                  </th>
                  <th className="p-2 align-middle" style={tableHeaderStyle}>
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {isLoading && (
                  <tr>
                    <td colSpan={4} className="text-center p-5">
                      <Loader />
                    </td>
                  </tr>
                )}
                {!isLoading && listData.length === 0 && (
                  <RowEmpty colSpan={4} />
                )}
                {!isLoading &&
                  listData.length > 0 &&
                  listData?.map((data) => (
                    <tr key={data?.name}>
                      <td className="p-2 align-middle">
                        {data?.plan_date
                          ? convertDateWithTime(data?.plan_date, 'DD-MM-YYYY')
                          : '-'}
                      </td>
                      <td className="p-2 align-middle">{data?.name}</td>
                      <td className="p-2 align-middle">{data?.destination}</td>
                      <td className="p-2 align-middle" style={{ width: '20%' }}>
                        <div className="d-flex items-center gap-2">
                          <TableAction>
                            <button
                              className="btn btn-light text-secondary border rounded shadow-sm"
                              style={{
                                width: '35px',
                                height: '35px',
                                padding: 0
                              }}
                              onClick={() =>
                                navigate(
                                  `/arrival/material-transfer/detail/${encodeURIComponent(
                                    data?.name
                                  )}`,
                                  {
                                    state: {
                                      filter: filter,
                                      data: data
                                    }
                                  }
                                )
                              }
                            >
                              <Search size={14} />
                            </button>
                          </TableAction>
                          <button
                            className={`btn ${
                              disabledCreateML[data?.name] || data?.is_used
                                ? 'btn-secondary opacity-50'
                                : 'btn-primary-blue'
                            } btn-sm`}
                            onClick={() => {
                              setCreateMl({
                                ...data,
                                mlId: data?.name
                              })
                              setShow(true)
                            }}
                            disabled={
                              disabledCreateML[data?.name] || data?.is_used
                            }
                            style={{
                              borderRadius: '8px',
                              padding: '6px 16px',
                              fontSize: '0.85rem'
                            }}
                          >
                            {disabledCreateML[data?.name]
                              ? 'Creating...'
                              : '+ ML DRAFT'}
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
              <tfoot>
                <tr>
                  <td className="p-3 border-top-0" colSpan={4}>
                    <TablePagination
                      meta={meta}
                      handleOnChangeMeta={handleOnChangeMeta}
                      handlePageChange={handlePageChange}
                    />
                  </td>
                </tr>
              </tfoot>
            </Table>
          </Col>
        </Row>
        <ModalCreate
          show={show}
          onHide={() => setShow(false)}
          createMl={createMl}
          setCreateMl={setCreateMl}
          handleCreateMlDraft={handleCreateMlDraft}
          disableSubmit={disableSubmit}
          type="tr"
        />
      </Container>
    </>
  )
}

export default MaterialTransfer
